{
  "contacts-url-input.input.error.message.format-error": "Enter a web URL like https://www.example.com.",
  "field-context-menu.cut": "Cut",
  "search.keyword.basic.full-name": "full name, name, first and last",
  "input.error.message.incomplete-date-error.day-time": "Enter a day and time.",
  "field.signature.a11y.action-description.type": "Use the keyboard to type.",
  "input.error.message.required-error-forced": "This field is required.",
  "field-context-menu.show-field": "Show field",
  "date-picker.input.error.message.format-error": "Choose a date.",
  "form.login-bar.actions.login": "Log in",
  "date-picker.a11y.clear-button": "Clear",
  "form.file-upload.uploading": "Uploading {count, plural, =0 {...} other {#%...}}",
  "rating-input.a11y.reaction-label": "{count} {count, plural, =1 {star} other {stars}}",
  "contacts-company.input.error.message.required-error": "Enter a company name.",
  "search.keyword.events.rsvp": "rsvp, attendance, reply",
  "dext-phone.input.error.message.required-error": "Enter a phone number.",
  "search.keyword.quiz.short-text": "quiz short text, short answer",
  "field.signature.clear-button.label": "Clear",
  "input.error.message.type-error": "Choose a {type}.",
  "payment-input.input.error.message.required-error": "Enter a payment amount.",
  "form.login-bar.action.logout": "Log out",
  "date-picker.a11y.arrow-left": "Go to previous month",
  "search.keyword.address.address-line": "address line, street address, line 1",
  "mla-subdivision.input.error.message.required-error.tr": "Choose a city.",
  "search.keyword.dext.radio-group": "radio group, radio buttons, single select",
  "search.keyword.quiz.image-choice": "image choice, picture options",
  "input.error.message.value-range-error": "Enter a number from {minLimit} to {maxLimit}.",
  "input.error.message.incomplete-date-error.year-month": "Enter a month and year.",
  "search.keyword.ecom.company-name": "company name, business name",
  "mla-address-line.input.error.message.required-error": "Enter an address.",
  "search.keyword.ecom.email": "email, contact email",
  "search.keyword.scheduling.services-dropdown": "services dropdown, service list, select service",
  "contacts-position.input.error.message.required-error": "Enter a position or job title.",
  "bookings-phone.input.error.message.format-error": "Enter a valid phone number.",
  "input.error.message.incomplete-date-error.year-month-time": "Enter a month, time and year.",
  "search.keyword.transaction.donation": "donation, contribute, give, contribution",
  "field.number.aria-role-description": "Number",
  "signature.input.error.message.required-error": "Sign in the box above.",
  "field.date.label.month": "Month",
  "field.rich-text.read-more-button.label": "Read more",
  "field.time.label.period": "AM/PM setting",
  "search.keyword.dext.text-input": "text input, single line, field",
  "submit.failed.message": "We could not submit your form. Try again later.",
  "dext-email.input.error.message.required-error": "Enter an email address like example@mysite.com.",
  "mla-city.input.error.message.required-error.tr": "Enter a district.",
  "date-picker.a11y.calendar-button.role-description": "Calendar dialog pop up collapsed",
  "field.signature.a11y.action-description.draw-or-type": "Sign in the box or use the keyboard to type.",
  "field.time.perdiod.AM": "AM",
  "form.login-bar.title.logged-out-state": "Have an account? ",
  "form.appointment.slots-not-found.text": "There’s no availability for this date. Try selecting another date.",
  "input.error.message.format-error": "Use the format \"{format}.\"",
  "search.keyword.basic.date-picker": "date picker, calendar, pick date",
  "search.keyword.address.street-number": "street number, house number",
  "contacts-address.input.error.message.required-error": "Enter an address.",
  "field-context-menu.copy": "Copy to clipboard",
  "search.keyword.ecom.subscriptions": "subscriptions, subscribe, membership",
  "field.signature.a11y.state.empty": "Signature field is empty.",
  "dext-date-picker.input.error.message.min-value-error": "Enter a valid date after today’s date.",
  "payment-input.input.error.message.min-value-error": "Enter a payment amount greater than {currency}{limit}.",
  "search.keyword.multi-elements.radio-buttons": "radio buttons, single choice, option",
  "input.error.message.incomplete-date-error.year-time": "Enter a 4 digit year and time.",
  "field.signature.a11y.state.signed": "Signed.",
  "field.quiz-answer-feedback.wrong": "Incorrect",
  "search.keyword.scheduling.services-multi-choice": "services multi choice, multiple services",
  "mla-city.input.error.message.required-error": "Enter a city.",
  "field.rich-text.read-less-button.label": "Read less",
  "form.appointment.accessibility.calendar.previous-week.aria-label": "Show previous week",
  "search.keyword.dext.email": "email, e-mail address, mail",
  "field.signature.mode.upload.description": "Upload mode selected. Upload an image of your signature.",
  "field.quiz-file-upload.skipped": "This question was skipped. ",
  "ecom.email.label": "Email",
  "input.error.message.incomplete-date-error.year-month-day": "Enter a month, day and year.",
  "field-context-menu.make-optional": "Make optional",
  "contacts-subscribe.input.error.message.not-allowed-value": "Check the box to continue.",
  "field.signature.mode.draw.description": "Drawing mode selected. Drawing requires a mouse or touchpad. For keyboard accessibility, select Type or Upload.",
  "checkbox.input.error.message.required-error": "Check the box to continue.",
  "date-picker.input.error.message.required-error": "Choose a date.",
  "dext-tags.input.error.message.required-error": "Choose an option.",
  "field-context-menu.delete": "Delete",
  "field.date.label.year": "Year",
  "mla-address-line-2.input.error.message.required-error": "Enter a second address line (e.g., apartment, suite, floor).",
  "search.keyword.basic.signature": "signature, sign, e-sign, autograph",
  "form.login-bar.title.logged-in-state": "Logged in as {user}",
  "payment-input.input.error.message.max-value-error": "Enter a payment amount less than {currency}{limit}.",
  "ecom-phone.input.error.message.required-error": "Enter a phone number.",
  "payment-input.input.error.message.value-range-error": "Enter a payment amount between {currency}{minLimit} and {currency}{maxLimit}.",
  "search.keyword.dext.date-picker": "date picker, calendar",
  "input.error.message.incomplete-date-error.year-day": "Enter a day and year.",
  "submission-table.signature.not-signed": "Not signed",
  "dext-url-input.input.error.message.format-error": "Enter a web URL like https://www.example.com.",
  "ecom-phone.input.error.message.pattern-error": "Enter a valid phone number.",
  "contacts-phone.input.error.message.not-allowed-value": "Phone numbers with this country code aren’t accepted.",
  "vat-id.input.error.message.required-error.il": "Enter a valid 9 digit ID (“teudat zehut”) or Company number (“het pey”).",
  "input.error.message.incomplete-date-error.day": "Enter a day.",
  "date-input.input.error.message.min-value-error": "Enter a valid date after today’s date.",
  "input.error.message.invalid-location-id-error": "Location is invalid",
  "search.keyword.basic.rating-input": "rating, stars, score, review",
  "input.error.message.max-length-error": "Enter less than {limit, plural, one {# character} other {# characters}}.",
  "field.date.placeholder.day": "Day",
  "search.keyword.dext.tags": "tags, chips, labels",
  "services-dropdown.input.error.message.required-error": "Select a Service",
  "ecom-email.input.error.message.required-error": "Enter an email address like example@mysite.com.",
  "dext-phone.input.error.message.not-allowed-value": "Phone numbers with this country code aren’t accepted.",
  "dext-url-input.input.error.message.required-error": "Enter a web URL like https://www.example.com.",
  "contacts-date-input.input.error.message.format-error": "Enter a month, day and year.",
  "search.keyword.multi-elements.dropdown": "dropdown, select, chooser, menu",
  "signature.input.error.message.required-error.with-upload": "Sign in the box above or upload your signature.",
  "contacts-phone.input.error.message.required-error": "Enter a phone number.",
  "search.keyword.quiz.file-upload": "quiz file upload, attachment",
  "search.keyword.dext.checkbox-group": "checkbox group, multiple checkboxes",
  "field.phone.country-selector-button.aria-label": "Select a country code",
  "search.keyword.identity.password": "password, passcode, secret",
  "field-context-menu.move-up": "Move up",
  "search.keyword.basic.time": "time, clock, hour, minute",
  "dext-text-input.input.error.message.required-error": "Enter an answer.",
  "settings.required-indicator-text": "(Required)",
  "file-upload.dropzone.overlay.button": " Drop your files here",
  "search.keyword.address.apartment": "apartment, unit, suite, floor",
  "field.time.perdiod.PM": "PM",
  "contacts-birthdate.input.error.message.format-error": "Enter a month, day and year.",
  "field.quiz-answer-feedback.correct": "Correct",
  "search.keyword.basic.long-answer": "long answer, paragraph, multiline, textarea",
  "vat-id.input.error.message.required-error": "Enter a CPF/CNPJ number.",
  "search.keyword.events.repeater": "repeater, list, repeating group",
  "bookings-email.input.error.message.format-error": "Enter an email address like example@mysite.com.",
  "search.keyword.contacts.email": "email, e-mail, mail, address",
  "input.error.message.character-length-range-error": "Enter between {minLimit} and {maxLimit} characters.",
  "bookings-phone.input.error.message.not-allowed-value": "Phone numbers with this country code aren’t accepted.",
  "search.keyword.transaction.fixed-payment": "fixed payment, set amount, one-time",
  "contacts-email.input.error.message.format-error": "Enter an email address like example@mysite.com.",
  "search.keyword.dext.checkbox": "checkbox, tick, boolean",
  "dropdown.input.error.message.required-error": "Choose an option.",
  "dext-text-area.input.error.message.required-error": "Enter an answer.",
  "field.signature.settings.upload-button.label": "Upload Image",
  "field.date.placeholder.month": "Month",
  "form.error.prefix.a11y": "Error:",
  "contacts-tax-id.input.error.message.required-error": "Enter a VAT ID number.",
  "contacts-number-input.input.error.message.required-error": "Enter a number.",
  "date-picker.a11y.aria-label": "Show date picker",
  "field.phone.country-search-input.aria-label": "Search",
  "search.keyword.basic.submit": "submit, send, save, continue",
  "field.signature.a11y.state.drawing": "Writing signature...",
  "input.error.message.unknown-value-error": "Must have additional properties.",
  "dext-date-picker.input.error.message.max-value-error": "Enter a valid date from January 1, 1000 to today.",
  "search.keyword.bookings.header": "header, title, section heading",
  "search.keyword.basic.date": "date, calendar, day, pick a date",
  "form.appointment.empty-state.notification.text": "Currently, there’s no available time slots to schedule. Contact us to complete your request.",
  "mla-country.input.error.message.required-error": "Choose a country/region.",
  "field.time.label.hours": "Hours",
  "search.keyword.basic.nested-form": "nested form, subform, repeater group, group",
  "file-upload.delete-file.aria-label": "Delete file",
  "field.vat-id.label-br": "CPF/CNPJ",
  "ecom-header.contact-details": "Customer details",
  "input.error.message.invalid-staff-id-error": "This field is invalid.",
  "search.keyword.contacts.subscribe": "subscribe, subscription, opt in, newsletter, marketing, subscriber",
  "date-input.input.error.message.format-error": "Enter a month, day and year.",
  "contacts-first-name.input.error.message.required-error": "Enter a first name.",
  "file-upload.dropzone.title": "Upload your file",
  "search.keyword.scheduling.appointment": "appointment, booking, schedule",
  "form.a11y.step.index.title": "Step {index} out of {total}",
  "field-context-menu.move-down": "Move down",
  "contacts-url-input.input.error.message.required-error": "Enter a web URL like https://www.example.com.",
  "field.time.label.minutes": "Minutes",
  "dext-phone.input.error.message.format-error": "Enter a valid phone number.",
  "bookings-phone.input.error.message.required-error": "Enter a phone number.",
  "search.keyword.multi-elements.tags": "tags, chips, labels, keywords",
  "form.file-upload.explanation-text": "{count, plural, =1 {# file} other {# files}} uploaded",
  "contacts-last-name.input.error.message.required-error": "Enter a last name.",
  "field.signature.mode.selector.aria-label": "Signature input mode",
  "field.signature.mode.draw.label": "Draw",
  "mla-postal-code.input.error.message.pattern-error": "Enter a valid zip/postal code.",
  "date-picker.a11y.dropdown-year": "Select year",
  "time-input.input.error.message.format-error": "Enter hours and minutes.",
  "field-context-menu.hide-field": "Hide field",
  "search.keyword.basic.number": "number, numeric, quantity, digits",
  "input.error.message.not-allowed-value": "The chosen value is not allowed.",
  "input.error.message.min-value-error": "Enter a number that is {limit} or more.",
  "search.keyword.dext.number-input": "number input, numeric field",
  "input.error.message.incomplete-date-error.month-day": "Enter a month and day.",
  "field.date.placeholder.time": "HH:MM",
  "submit.checkout.message": "Redirecting to checkout...",
  "input.error.message.invalid-phone-country-code-error": "Enter a valid country code.",
  "mla-street-name.input.error.message.required-error": "Enter a street name.",
  "search.keyword.bookings.first-name": "first name, given name",
  "bookings-first-name.input.error.message.required-error": "Enter a first name.",
  "vat-id.input.error.message.format-error": "Enter a valid CPF/CNPJ number.",
  "search.keyword.contacts.first-name": "first name, given name, forename",
  "form.appointment.accessibility.calendar.next-week.aria-label": "Show next week",
  "donation.input.error.message.required-error": "Choose a donation amount.",
  "input.error.message.incomplete-date-error.month": "Enter a month.",
  "input.error.message.incomplete-date-error.year": "Enter a 4 digit year.",
  "vat-id.input.error.message.format-error.il": "Enter a valid 9 digit ID (“teudat zehut”) or Company number (“het pey”).",
  "search.keyword.quiz.single-choice": "quiz single choice, one answer",
  "field.phone.aria-label": "Phone",
  "field.signature.canvas.aria-label.empty": "Signature drawing area (empty)",
  "file-upload.dropzone.limit-reached.title": "You’ve reached the file upload limit.",
  "search.keyword.transaction.payment-input": "payment input, amount, pay",
  "search.keyword.contacts.tax-id": "tax id, vat, tin, ein, tax number",
  "form.appointment.accessibility.calendar.has-availability.aria-label": "This day has available time slots.",
  "bookings-phone.input.error.message.pattern-error": "Enter a valid phone number.",
  "search.keyword.bookings.last-name": "last name, surname",
  "input.error.message.incomplete-date-error.month-time": "Enter a month and time.",
  "product-list.input.error.message.required-error": "Choose an option.",
  "field-context-menu.move-to-next-page": "Move to next page",
  "mla-postal-code.input.error.message.required-error": "Enter a zip/postal code.",
  "file-upload.input.error.message.required-error": "Upload a file.",
  "vat-id.input.error.message.format-error.br": "Enter a valid CPF/CNPJ number.",
  "input.error.message.exact-character-length-error": "Enter exactly {limit, plural, one {# character} other {# characters}}.",
  "submission-table.signature.signed": "Signed",
  "search.keyword.contacts.last-name": "last name, surname, family name",
  "search.keyword.quiz.number": "quiz number, numeric question",
  "search.keyword.dext.text-area": "text area, multiline, paragraph",
  "input.error.message.incomplete-date-error": "Enter a month, day and year.",
  "ecom-email.input.error.message.format-error": "Enter an email address like example@mysite.com.",
  "field.vat-id.label-il": "ID/Company number",
  "text-input.input.error.message.required-error": "Enter an answer.",
  "url-input.input.error.message.required-error": "Enter a web URL like https://www.example.com.",
  "ecom-header.shipping-details": "Delivery details",
  "service-dropdown.input.error.message.required-error": "Select a Service",
  "field.signature.mode.type.description": "Type mode selected. Type your signature using the keyboard.",
  "input.error.message.incomplete-date-error.year-day-time": "Enter a day, time and year.",
  "number-input.input.error.message.required-error": "Enter a number.",
  "field.signature.mode.upload.label": "Upload",
  "input.error.message.unknown-error": "Unknown error, please contact Support.",
  "input.error.message.max-items-error": "Choose up to {limit, plural, one {# option} other {# options}}.",
  "search.keyword.basic.multiline-address": "multiline address, full address, address block",
  "file-upload.popover.aria-label": "List of uploaded files",
  "search.keyword.address.street-name": "street name, road, avenue",
  "search.keyword.layout-elements.login-bar": "login bar, member bar, account",
  "input.error.message.multiple-of-value-error": "Choose a multiple of {multipleOf}.",
  "full-name-last-name.input.error.message.required-error": "Enter a last name.",
  "search.keyword.ecom.shipping-details": "shipping details, delivery, shipping address",
  "field-context-menu.paste": "Paste",
  "search.keyword.basic.full-name-last-name": "last name, surname",
  "input.error.message.pattern-error": "Match the pattern \"{pattern}\".",
  "dext-number-input.input.error.message.required-error": "Enter a number.",
  "field-context-menu.ai-assistant": "Ask AI",
  "field-context-menu.move-to-previous-page": "Move to previous page",
  "dext-date-picker.input.error.message.required-error": "Choose a date.",
  "search.keyword.address.city": "city, town",
  "date-input.input.error.message.max-value-error": "Enter a valid date from January 1, 1000 to today.",
  "dext-checkbox-group.input.error.message.required-error": "Choose an option.",
  "file-upload.dropzone.subtitle": "Choose a file or drag and drop one here.",
  "dext-radio-group.input.error.message.required-error": "Choose an option.",
  "search.keyword.multi-elements.multi-checkbox": "multi checkbox, checkboxes, multiple selection",
  "search.keyword.basic.short-answer": "short answer, text, single line, input",
  "checkbox.input.error.message.not-allowed-value": "Check the box to continue.",
  "contacts-birthdate.input.error.message.max-value-error": "Enter a date from January 1, 1900 to today.",
  "search.keyword.dext.rating-input": "rating input, stars, score, review",
  "search.keyword.dext.url-input": "url input, link, website, web address",
  "input.error.message.incomplete-date-error.month-day-time": "Enter a month, day and time.",
  "file-upload.aria-roledescription": "File upload",
  "search.keyword.basic.vat-id": "vat id, vat number, tax id",
  "contacts-phone.input.error.message.pattern-error": "Enter a valid phone number.",
  "mla-street-number.input.error.message.required-error": "Enter a house number.",
  "search.keyword.ecom.contact-details": "contact details, customer info",
  "date-picker.a11y.dropdown-month": "Select month",
  "field.signature.mode.type.label": "Type",
  "search.keyword.contacts.address": "address, location, street, city, country, postal code, area",
  "search.keyword.bookings.phone": "phone, contact number, telephone, mobile",
  "search.keyword.address.subdivision": "state, province, region, subdivision",
  "date-picker.input.error.message.min-value-error": "Enter a valid date after today’s date.",
  "date-time-input.input.error.message.min-value-error": "Enter a valid date after today’s date.",
  "dext-checkbox.input.error.message.required-error": "Check the box to continue.",
  "url-input.input.error.message.format-error": "Enter a web URL like https://www.example.com.",
  "add-other.default-other-option-label": "Other",
  "dext-checkbox.input.error.message.not-allowed-value": "Check the box to continue.",
  "field.date.placeholder.year": "Year",
  "date-picker.input.error.message.max-value-error": "Enter a valid date from January 1, 1000 to today.",
  "search.keyword.bookings.rich-text": "rich text, formatted text, description",
  "field.signature.text.placeholder": "Type your signature",
  "dext-date-picker.input.error.message.format-error": "Choose a date.",
  "form.file-upload.error.upload-limit": "There is an upload limit of {limit, plural, one {# file} other {# files}}.",
  "checkbox-group.input.error.message.required-error": "Choose an option.",
  "rating-input.input.error.message.required-error": "Choose a star rating.",
  "field.mla-apartment.label": "Apartment",
  "text-area.input.error.message.required-error": "Enter an answer.",
  "field.phone.country-search-input.placeholder": "Search",
  "search.keyword.layout-elements.header": "header, page header, top bar",
  "search.keyword.ecom.additional-info": "additional info, notes, instructions",
  "donation.other-option.placeholder": "Enter an amount",
  "dext-rating-input.input.error.message.required-error": "Choose a star rating.",
  "field.signature.a11y.action-description.draw": "Sign in the box.",
  "search.keyword.ecom.full-name": "full name, recipient name, first and last",
  "contacts-birthdate.input.error.message.min-value-error": "Enter a date from January 1, 1900 to today.",
  "mla-subdivision.input.error.message.required-error": "Choose an option.",
  "dext-dropdown.input.error.message.required-error": "Choose an option.",
  "contacts-text-input.input.error.message.required-error": "Enter an answer.",
  "search.keyword.dext.phone": "phone, telephone, mobile",
  "field.date.label.day": "Day",
  "search.keyword.basic.url": "url, website, link, web address",
  "vat-id.input.error.message.required-error.br": "Enter a CPF/CNPJ number.",
  "search.keyword.bookings.email": "email, contact email, mail",
  "date-picker.calendar.close-button": "Close",
  "search.keyword.contacts.phone": "phone, telephone, mobile, cell, number",
  "input.error.message.invalid-value-for-pattern": "Enter a valid answer.",
  "radio-group.input.error.message.required-error": "Choose an option.",
  "input.error.message.min-items-error": "Choose at least {limit, plural, one {# option} other {# options}}.",
  "ecom.form.field-type.ecom-subscriptions.label": "I agree to receive news to the email address and/or phone numbers added",
  "search.keyword.ecom.phone": "phone, contact number, telephone, mobile",
  "input.error.message.decimal_point_error": "Add {number} number(s) after the decimal point.",
  "bookings-email.input.error.message.required-error": "Enter an email address like example@mysite.com.",
  "search.keyword.layout-elements.rich-text": "rich text, formatted content, paragraph",
  "contacts-subscribe.input.error.message.required-error": "Check the box to continue.",
  "search.keyword.dext.dropdown": "dropdown, select, menu",
  "search.keyword.address.postal-code": "postal code, zip, postcode",
  "form.appointment.show-more-slots.text": "Show more slots",
  "form.file-upload.error.upload-failed": "File upload failed.",
  "dext-email.input.error.message.format-error": "Enter an email address like example@mysite.com.",
  "full-name-first-name.input.error.message.required-error": "Enter a first name.",
  "field-context-menu.settings": "Settings",
  "search.keyword.quiz.multi-choice": "quiz multiple choice, multi select",
  "search.keyword.address.address-line-2": "address line 2, apt, suite, unit",
  "bookings-last-name.input.error.message.required-error": "Enter a last name.",
  "actions.rules.button.label_DELETE_THIS": "Rules",
  "search.keyword.transaction.product": "product, item, sku, purchase",
  "appointment.input.error.message.required-error": "This field is required.",
  "field-context-menu.make-required": "Make required",
  "search.keyword.contacts.position": "position, job title, role, occupation",
  "search.keyword.bookings.address": "address, location",
  "search.keyword.multi-elements.checkbox": "checkbox, tick box, check",
  "date-time-input.input.error.message.format-error": "Enter a month, day and year.",
  "field.date.label.time": "Time",
  "search.keyword.basic.full-name-first-name": "first name, given name",
  "input.error.message.required-error": "This field is required.",
  "field.phone.country-selector-dropdown.no-result": "No results found...",
  "input.error.message.exact-items-number-error": "Choose {limit, plural, one {# option} other {# options}}.",
  "form.appointment.timezone.label": "Time zone",
  "search.keyword.address.country": "country, nation",
  "search.keyword.basic.file-upload": "file upload, attachment, upload, file",
  "date-time-input.input.error.message.max-value-error": "Enter a valid date from January 1, 1000 to today.",
  "date-picker.a11y.arrow-right": "Go to next month",
  "search.keyword.quiz.long-text": "quiz long text, paragraph",
  "input.error.message.incomplete-date-error.time": "Enter a time.",
  "field.signature.canvas.aria-label.signed": "Signature drawing area (signed)",
  "contacts-phone.input.error.message.format-error": "Enter a valid phone number.",
  "tags.input.error.message.required-error": "Choose an option.",
  "search.keyword.contacts.birthdate": "birthdate, birthday, date of birth, dob",
  "search.keyword.basic.date-time": "date time, datetime, timestamp, schedule",
  "file-upload.dropzone.limit-reached.subtitle": "Delete a file to add a different one.",
  "input.error.message.max-value-error": "Enter a number that is {limit} or less.",
  "input.error.message.min-length-error": "Enter at least {limit, plural, one {# character} other {# characters}}.",
  "form.appointment.meeting-format.in-person-location-method-os-location": "Business location",
  "form.file-upload.error.limit": "You've reached your upload limit of {limit, number} files.",
  "contacts-email.input.error.message.required-error": "Enter an email address like example@mysite.com.",
  "field-context-menu.duplicate": "Duplicate"
}
